import Moment from "moment";
export function formatHandoverDate(date) {
    if (Moment().format('D/M/Y') === Moment(date).format('D/M/Y')) {
        return 'Today at ' + Moment(date).format('h:mma');
    }
    else if (Moment().add(1, 'days').format('D/M/Y') === Moment(date).format('D/M/Y')) {
        return 'Tomorrow at ' + Moment(date).format('h:mma');
    }
    if (Moment(date).isAfter(Moment())) {
        return Moment(date).format('ddd Do [at] h:mma');
    }
    return Moment(date).format('DD/MM/YYYY');
}
export default formatHandoverDate;
